import { ModalFullscreen, Spinner } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './ChatModal.css';

export interface IChatModalProps {
  src: string;
  isOpen: boolean;
  onClose(): void;
}

export const ChatModal: React.FC<IChatModalProps> = ({ src, isOpen, onClose }) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const onLoad = () => setIsLoading(false);

  return (
    <ModalFullscreen onClose={onClose} open={isOpen} theme="white">
      <div className={styles['iframe-container']}>
        <span className={styles['close']}>
          <IconActionClose16 aria-label="Закрыть" color="icon-primary-default" onClick={onClose} />
        </span>
        {isLoading && (
          <span className={styles['spinner']} data-testid="spinner">
            <Spinner size={16} />
          </span>
        )}
        <iframe data-testid="ChatModal" className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
      </div>
    </ModalFullscreen>
  );
};
